"use client";

import { useAppSelector, useAppDispatch } from "@/lib/hooks";
import { contactUsSchema } from "@/utils/validation/ContactUsSchema";
import { ErrorMessage, Form, Formik } from "formik";
import React from "react";
import { InputField, Loader, PhoneField, TextareaField } from "@/components/ui";
import { contactUs, getCoutactUsLoading } from "@/lib/features/home/homeSlice";

interface FormValues {
  name: string;
  email: string;
  phone_number: string;
  phone_code: string;
  subject: string;
  message: string;
}

const ContactForm = () => {
  const isLoading = useAppSelector(getCoutactUsLoading);
  const dispatch = useAppDispatch();
  const initialValues: FormValues = {
    name: "",
    email: "",
    phone_number: "",
    phone_code: "",
    subject: "",
    message: "",
  };
  const onSubmit = async (data: FormValues) => {
    const numbersOnly = data?.phone_number?.replace(/\D/g, '');
    dispatch(contactUs({ url: "v1/contact-us", payload: {...data, phone_code: numbersOnly != "" ? data?.phone_code : "", phone_number:numbersOnly, phone: undefined,phone_country_code: undefined} }));
  };
  //

  return (
    <>
      {isLoading && <Loader show={isLoading} />}
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={contactUsSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form className="row y-gap-20 pt-20" id="contact-us">
           
            <div className="col-12">
              <InputField name="name" label="Name" type="text" />
            </div>
            <div className="col-12">
              <InputField name="email" label="Email" type="email" />
            </div>
            <div className="col-12 position-relative">
              <PhoneField
                name="phone"
                onValueChange={(
                  phone: string,
                  details: { country: any; inputValue: any }
                ) => {
                  const data = details?.inputValue?.split(" ");
                  const combined = data?.slice(1)?.join('');
                  setFieldValue("phone_number", combined);
                  setFieldValue("phone_code", data[0]);
                }}
              />
              {/* {JSON.stringify(values)} */}
              {/* Display phone_number validation error */}
              {touched.phone_number && errors.phone_number && (
                <span className="error-message pt-10 pl-15 text-red-500">
                  {errors.phone_number}
                </span>
              )}
              {/* Alternative: Using Formik's ErrorMessage component */}
              {/* <ErrorMessage
                name="phone_number"
                component="span"
                className="error-message pt-10 text-red-500"
              /> */}
            </div>
            <div className="col-12">
              <InputField
                id="subject"
                name="subject"
                label="Subject"
                type="text"
              />
            </div>
            <div className="col-12">
              <TextareaField
                resize="none"
                name="message"
                id="message"
                rows={4}
                label="Your Message"
              ></TextareaField>
            </div>
            <div className="col-auto">
              <button
                type="submit"
                className="button px-24 h-50 -dark-1 bg-blue-1 text-white"
              >
                Send Message
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ContactForm;
